import { ExternalChartComponentProps } from '../../data-viz-containers/common/types';
import {
  KpiFactboxSingleMetricViz,
  KpiFactboxSingleMetricVizProps,
} from '../../data-viz-containers/kpi-factbox-single-metric/SingleMetricKpiFactboxViz';
import {
  StoryboardComponentIds,
  StoryboardComponentSettings,
} from '../common/types';
import { FactboxSingleMetricStoryboardComponentConfig } from './types';

const componentConfigToVizContainerProps = (
  componentConfig: FactboxSingleMetricStoryboardComponentConfig,
  externalProps: ExternalChartComponentProps,
  persistenceKey: string
) => {
  return {
    dataConfig: componentConfig.dataConfig,
    selectedView: componentConfig.selectedView,
    externalProps: externalProps,
    persistenceKey: persistenceKey,
  };
};

export const factboxSingleMetricStoryboardComponentSettings: StoryboardComponentSettings<
  FactboxSingleMetricStoryboardComponentConfig,
  KpiFactboxSingleMetricVizProps
> = {
  componentId: StoryboardComponentIds.FACTBOX_SINGLE_METRIC,
  componentConfigToVizContainerProps: componentConfigToVizContainerProps,
  VizContainerComponent: KpiFactboxSingleMetricViz,
  validateConfig: (componentConfig) => {
    return {
      isValid: true,
      error: null,
    };
  },
};
